import { Formik, FieldArray } from 'formik';
import { Grid, TextField, Box, Button, List } from 'components/ui';
import { WideForm } from 'components/styles_components/form';
import { FormattedMessage, useIntl } from 'react-intl';
import { TitleTypography } from 'components/styles_components/typography';
import DatePicker from 'components/form/date_picker';
import ResultSelect from 'components/form/result_select';
import InspectionFieldExecuteItem from 'components/inspection_field/execute_item';

const EditForm = ({ initialValues, processing, onSubmit, onCancel }) => {
  const intl = useIntl();

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {(formik) => (
        <WideForm onSubmit={formik.handleSubmit}>
          <TitleTypography>
            <FormattedMessage id="form.inspection.section.when" />
          </TitleTypography>
          <DatePicker
            className="full-width margin-top-10"
            name="doneAt"
            id="doneAt"
            label={intl.formatMessage({ id: 'form.inspection.input.done_at' })}
            value={formik.values.doneAt}
            onChange={(value) => formik.setFieldValue('doneAt', value)}
          />
          <Grid className="margin-top-10">
            <ResultSelect
              className="full-width"
              name="result"
              id="result"
              label={intl.formatMessage({ id: 'form.inspection.input.result' })}
              value={formik.values.result}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={(formik.touched.result && Boolean(formik.errors.result)) || undefined}
              helperText={formik.touched.result && formik.errors.result}
            />
          </Grid>
          <FieldArray
            name="inspectionFields"
            validateOnChange={false}
            render={() => (
              <List>
                {formik.values.inspectionFields.map((obj, index) => (
                  <InspectionFieldExecuteItem
                    key={obj.id ?? index}
                    index={index}
                    obj={obj}
                    processing={processing}
                    setFieldValue={formik.setFieldValue}
                  />
                ))}
              </List>
            )}
          />
          <TextField
            fullWidth
            multiline
            margin="dense"
            id="notes"
            name="notes"
            label={intl.formatMessage({ id: 'form.inspection.input.notes' })}
            value={formik.values.notes ?? ''}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.notes && Boolean(formik.errors.notes)) || undefined}
            helperText={formik.touched.notes && formik.errors.notes}
          />
          <Button
            fullWidth
            className="margin-top-10"
            disabled={!formik.isValid || processing || !formik.dirty}
            color="primary"
            variant="contained"
            type="submit"
          >
            <FormattedMessage id="button.save" />
          </Button>
          <Box display="flex" justifyContent="flex-end">
            <Button size="small" variant="text" disabled={processing} onClick={onCancel}>
              <FormattedMessage id="button.cancel" />
            </Button>
          </Box>
        </WideForm>
      )}
    </Formik>
  );
};

export default EditForm;
